import officialPostalCodeBase from '../assets/official-postal-code-base.json'

interface Commune {
    code_commune_insee: string;
    nom_de_la_commune: string;
    code_postal: string;
    libelle_d_acheminement: string;
    ligne_5: string;
    _geopoint: string;
}

export const getDepartementCode = (codePostal: string): string => {
    const commune = (officialPostalCodeBase as Commune[]).find(c => c.code_postal.toString() === codePostal.toString() );
    console.log( "commune base", commune?.code_commune_insee )
    return commune ? commune.code_commune_insee : "";
};